import { render, staticRenderFns } from "./rec_loiter.vue?vue&type=template&id=2d3383d3&scoped=true&"
import script from "./rec_loiter.vue?vue&type=script&lang=js&"
export * from "./rec_loiter.vue?vue&type=script&lang=js&"
import style0 from "./rec_loiter.vue?vue&type=style&index=0&id=2d3383d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3383d3",
  null
  
)

export default component.exports